<template>
    <div>
        <!-- Table section -->
            <v-overlay :value="overlay">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
            </v-overlay>

            <v-card>
                <v-card-title>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="6" md="2" sm="6">
                            <v-menu
                                v-model="menuDateFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="from_date"
                                        :label="$t('dateFrom')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :first-day-of-week="0"
                                    v-model="from_date"
                                    @input="menuDateFrom = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6" md="2" sm="6">

                            <v-menu
                                v-model="menuDateTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="to_date"
                                        :label="$t('dateTo')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        dense
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :first-day-of-week="0"
                                    v-model="to_date"
                                    @input="menuDateTo = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="6" md="2" sm="6">
                            <v-text-field
                                v-model="search"
                                :label="$t('search')"
                                single-line
                                outlined
                                dense
                                clearable
                            >
                            </v-text-field>
                        </v-col>

                         <v-col cols="12" md="2" sm="12">
                            <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
                                <v-icon class="mr-1"> mdi-magnify </v-icon>
                            </v-btn>

                            <v-btn @click="exportExcel('exportExcel')" outlined>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-data-table
                    id="exportExcel"
                    :loading="loading"
                    :headers="headers"
                    :items="listInvoice"
                    :search="search"
                    hide-default-footer
                    class="elevation-1"
                    :server-items-length="totalPage"
                    :items-per-page="itemsPerPage"
                    :page.sync="currentPage"
                    :options.sync="options"
                    :mobile-breakpoint="0"
                >
                    <!-- Header -->
                    <template v-slot:progress class="text-center"><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>
                    <template v-slot:header.loading_date="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.unloading_date="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.buy_from_crop_trader="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.supplier_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.client_name="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.total_quantity="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.total_cost="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.total_sell="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.total_margin="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.paid_amount="{ header }">{{ $t(header.text) }}</template>
                    <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

                    <!-- Body section -->
                    <template v-slot:item.loading_date="{ item }">{{ item.loading_date | dateFormat}}</template>
                    <template v-slot:item.unloading_date="{ item }">{{ item.accepted_date | dateFormat}}</template>
                    <template v-slot:item.reference="{ item }">{{ item.reference }}</template>
                    <template v-slot:item.buy_from_crop_trader="{ item }">{{ item.buy_from_crop_trader }}</template>
                    <template v-slot:item.supplier_name="{ item }">{{ item.supplier_name }}</template>
                    <template v-slot:item.client_name="{ item }">{{ item.client_name }}</template>
                    <template v-slot:item.total_quantity="{ item }">{{ item.total_quantity }}</template>
                    <template v-slot:item.total_cost="{ item }">{{ (item.total_cost ? item.total_cost : 0) | formatNumber }} </template>
                    <template v-slot:item.total_sell="{ item }">{{ (item.total_sell ? item.total_sell : 0) | formatNumber }} </template>
                    <template v-slot:item.total_margin="{ item }">{{ (item.total_margin ? item.total_margin : 0) | formatNumber }} </template>
                    <template v-slot:item.total_amount="{ item }">{{ (item.total_amount ? item.total_amount : 0) | formatNumber }} </template>
                    <template v-slot:item.paid_amount="{ item }">{{ (item.paid_amount ? item.paid_amount : 0) | formatNumber }} </template>

                      <!-- Action -->
                    <template v-slot:item.action="{ item }">
                        <v-btn color="success" small rounded class="table-action-button no-text-transform mr-2" v-if="item.paid_status != 'paid'" @click="handlePayment(item.id, item.client_id, $event)"><font-awesome-icon icon="dollar-sign" class="mr-1"/> {{ $t('payment') }}</v-btn>
                        <v-btn color="teal" outlined class="table-action-button" text icon :to="{ name: 'beeshop.buyback.buyback-trading.bill-invoice-print', params: { id: item.id, type: 'invoice'}}"> <font-awesome-icon icon="print"/></v-btn>
                    </template>
                </v-data-table>

                <!-- Pagination -->
                <div class="text-center pt-2">
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
                        <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
                            <v-select
                                :label="$t('perPage')"
                                v-model="itemsPerPage"
                                :items="pageList"
                            ></v-select>
                        </v-col>

                        <v-pagination
                            v-model="currentPage"
                            :length="pageCount"
                            circle
                            prev-icon="mdi-menu-left"
                            next-icon="mdi-menu-right"
                            :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
                        ></v-pagination>

                        <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
                            <v-text-field
                                v-model="currentPageComputed"
                                :max="pageCount"
                                min="1"
                                type="number"
                                :label="$t('goto')"
                            ></v-text-field>
                        </v-col>
                    </v-card-actions>
                </div>
            </v-card>
        <!-- End Table section -->

        <!-- Payment section -->
            <buyback-payment-sale></buyback-payment-sale>
        <!-- End Payment section -->

    </div>
</template>

<script>
    import MainMixin from "../../../mixins/mainMixin";
    import OptionDataMixin from "../../../mixins/optionDataMixin";
    import _ from "lodash";
    import buybackPaymentSale from './buybackPaymentSale';


    export default {
        name: "buybackSale",
        mixins: [MainMixin, OptionDataMixin],
        components: {buybackPaymentSale},
        data() {
            return {

                headers: [
                    {text: "loading_date", value: "loading_date", filterable: false},
                    {text: "unloading_date", value: "unloading_date", filterable: false},
                    {text: "reference", value: "reference"},
                    {text: "buy_from_crop_trader", value: "buy_from_crop_trader"},
                    {text: "supplier", value: "supplier_name"},
                    {text: "client", value: 'client_name'},
                    {text: "quantity_in_kg", value: 'total_quantity'},
                    {text: "total_cost", value: "total_cost"},
                    {text: "total_price", value: "total_sell"},
                    {text: "total_margin", value: "total_margin"},
                    {text: "grand_total", value: "total_amount"},
                    {text: "total_paid", value: "paid_amount"},
                    {text: "action", value: "action", width: 50, sortable: false}
                ],
            };
        },

        methods: {

            fetchDataTable: _.debounce(function () {
                let vm = this;
                vm.fetchListInvoice({
                    search: vm.search,
                    type_order: "",
                    contact_id: "",
                    id: "",
                    offset: vm.currentPage,
                    limit: vm.itemsPerPage,
                    sortBy: vm.options.sortBy[0] || "created_at",
                    sortDesc: vm.options.sortDesc[0] === false ? 0 : 1,
                    from_date: vm.from_date,
                    to_date: vm.to_date,
                })
            }, 350),

            handleSearch(){
                this.fetchDataTable();
            },

            handlePayment(transaction_id, client_id){
                this.$store.dispatch('updateBuybackDialogPayment', {dialog_sale: true, transaction_id: transaction_id, client_id: client_id});
            },

        },
        computed: {
             dialogPayment(){
                return this.$store.state.buyback.dialog_sale;
            }
        },
        watch: {
             dialogPayment(val){
                if(! val){
                    this.fetchDataTable();
                }
            },
            
            currentPage() {
                this.loading = true;
                this.fetchDataTable();
            },
            itemsPerPage() {
                this.loading = true;
                this.fetchDataTable();
            },
        },
        created() {}
    };
</script>